@if (separateLogicForMobileAndDesktop) {
  @if (isAppliedToDesktop && !canApplyBrandToMobile) {
    <div class="link-to-brand-var-wrapper" [ngClass]="customClass">
      <a
        class="link-to-brand-var"
        [routerLink]="['/settings/customization']"
        target="_blank"
        rel="noopener noreferrer"
        [innerHTML]="'settings.customization.brand-title' | translate"></a>
      {{ "generic.applied-to-desktop" | translate }}
    </div>
  }

  @if (isAppliedToBoth) {
    <div class="link-to-brand-var-wrapper" [ngClass]="customClass">
      <a
        class="link-to-brand-var"
        [routerLink]="['/settings/customization']"
        target="_blank"
        rel="noopener noreferrer"
        [innerHTML]="'settings.customization.brand-title' | translate"></a>
      {{ "generic.applied" | translate }}
    </div>
  }

  @if (isAppliedToMobile) {
    <div class="link-to-brand-var-wrapper" [ngClass]="customClass">
      <a
        class="link-to-brand-var"
        [routerLink]="['/settings/customization']"
        target="_blank"
        rel="noopener noreferrer"
        [innerHTML]="'settings.customization.brand-title' | translate"></a>
      {{ "generic.applied-to-mobile" | translate }}
    </div>
  }

  <div class="brand-setting-btn-wrapper" [ngClass]="customClass">
    @if (((!isAppliedToBoth && !isAppliedToMobile && !isAppliedToDesktop) || canApplyBrandToMobile) && brandSettingsValue && isDefaultValue) {
      <button class="secondary-button brand-setting-btn" (click)="applyBrandSettings()" [disabled]="disabled">
        {{ "settings.customization.brand-settings.apply-br" | translate }}
      </button>
    }
  </div>
}

@if (!separateLogicForMobileAndDesktop) {
  @if (isBrandSettingsValueApplied && brandSettingsValue && isDefaultValue) {
    <div class="link-to-brand-var-wrapper" [ngClass]="customClass">
      <a
        class="link-to-brand-var"
        [routerLink]="['/settings/customization']"
        target="_blank"
        rel="noopener noreferrer"
        [innerHTML]="'settings.customization.brand-title' | translate"></a>
      {{ "generic.applied" | translate }}
    </div>
  }
  <div class="brand-setting-btn-wrapper" [ngClass]="customClass">
    @if (!isBrandSettingsValueApplied && brandSettingsValue && isDefaultValue) {
      <button class="secondary-button brand-setting-btn" (click)="applyBrandSettings()" [disabled]="disabled">
        {{ "settings.customization.brand-settings.apply-br" | translate }}
      </button>
    }
  </div>
}
